import {
  Module,
  PATH_CLIENTS,
  PATH_PROJECTS,
  PATH_PROJECTS_SETTLEMENTS_DIRECTORY,
  PATH_PROJECT_CONTRACTOR_VISITS,
  PATH_STORES,
  PATH_PROJECTS_ROLE_BASED_ASSIGNMENTS,
  PATH_PROJECTS_CONTRACTOR_CARDS,
  PATH_INVOICE_SPECIFICATIONS,
} from "@/constants";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import {
  FolderClock,
  FolderGit,
  Users,
  UsersRound,
  Warehouse,
  UserCheck,
  IdCard,
  FileText,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavigationAnchor } from "@/components/layout/types";

export const useProjectMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const projectPermissions = useModulePermissions(Module.Projects);

  return [
    {
      icon: FolderClock,
      url: PATH_PROJECTS,
      permission: projectPermissions.can_read, // Mapped from projects_read_basic or projects_read_full
      title: t("projects.title.multiple"),
    },
    {
      icon: Warehouse,
      url: PATH_STORES,
      permission: permissions.stores.can_read,
      title: t("stores.title.multiple"),
    },
    {
      icon: Users,
      url: PATH_CLIENTS,
      permission: permissions.clients.can_read,
      title: t("clients.title.multiple"),
    },
    {
      icon: FolderGit,
      url: PATH_PROJECTS_SETTLEMENTS_DIRECTORY,
      permission: permissions[Module.ProjectSettlements].can_read,
      title: t("projectSettlements.title.multiple"),
    },
    {
      icon: FileText,
      url: PATH_INVOICE_SPECIFICATIONS,
      title: t("projectInvoiceSpecifications.title.multiple"),
      permission: permissions[Module.InvoiceSpecifications].can_read,
    },
    {
      icon: UsersRound,
      url: PATH_PROJECT_CONTRACTOR_VISITS,
      title: t("projectContractorVisits.title.multiple"),
      permission: permissions[Module.ContractorVisits].can_read,
    },
    {
      icon: IdCard,
      url: PATH_PROJECTS_CONTRACTOR_CARDS,
      title: t("contractorCards.title.multiple"),
      permission: permissions[Module.ContractorCards].can_read,
    },
    {
      icon: UserCheck,
      url: PATH_PROJECTS_ROLE_BASED_ASSIGNMENTS,
      title: t("contractorsAssignments.title.roleBased"),
      permission: permissions[Module.RoleBasedAssignments].can_read,
    },
  ];
};
